import { type FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import ODSearchForm, { type ODSearchFormProps } from '@Components/container/search/searchForm/ODSearchForm'
import WidgetErrorDialog from '@Components/utils/widget/errorDialog/WidgetErrorDialog'

import ODSearchExternalHeader, { type ODSearchExternalHeaderProps } from './_internal/ODSearchExternalHeader'
import * as styles from './styles'

type ODSearchExternalWidgetProps = Pick<ODSearchFormProps, 'onSubmit' | 'isExternalSubmitButton'> &
  ODSearchExternalHeaderProps

const ODSearchExternalWidget: FC<ODSearchExternalWidgetProps> = ({
  homePath,
  regionSudURL,
  isExternalSubmitButton,
  onSubmit,
}) => {
  const theme = useTheme()
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false)

  const showErrorDialog = () => {
    setIsErrorDialogOpen(true)
  }

  const hideErrorDialog = () => {
    setIsErrorDialogOpen(false)
  }

  return (
    <div css={styles.widgetContainer(theme)}>
      <ODSearchExternalHeader homePath={homePath} regionSudURL={regionSudURL} />
      <div css={styles.widgetContent(theme)}>
        <Typography css={styles.widgetTitle(theme)} component="h1" variant="h2" aria-hidden>
          <FormattedMessage id="home_searchField" />
        </Typography>
        <ODSearchForm
          elevation="onBackground"
          isColumnDirectionForced
          isExternalSubmitButton={isExternalSubmitButton}
          shouldIgnoreSuggestions
          onSubmit={onSubmit}
          onError={showErrorDialog}
        />
        <WidgetErrorDialog isOpen={isErrorDialogOpen} onClose={hideErrorDialog} />
      </div>
    </div>
  )
}

export default ODSearchExternalWidget
